module.exports = __webpack_public_path__ + "img/santa.c8e09a69.png";